export class MapsPrinter {
    constructor() {
        this.urlParam = 'openMap';
        this.eventDelegation();
        this.onLoadOpenModalMap();
    }

    eventDelegation() {
        $('body').on('click', '.map-container', () => {
            let infoWindow = $('[data-own-infowindow]');
            if (infoWindow.is(':visible')) {
                $('[data-own-infowindow]').hide();
            }
            if ($('.marker-selected').length == 0) {
                myApp.urlManager.setUrlParam(this.urlParam, '');
            }
        })

        $('body').on('click', '#modal_group_map [data-element="modal-close"]', () => {
            let infoWindow = $('[data-own-infowindow]');
            if (infoWindow.is(':visible')) {
                infoWindow.hide();
            }
        });
    }

    onLoadOpenModalMap() {
        window.addEventListener('load', () => {
            if (myApp.urlManager.checkUrlParam(this.urlParam) && document.querySelector('#modal_group_map.custom-modal') != null) {
                myApp.customModalManager.openModal('#modal_group_map');
            }
        });
    }


    activateMarker(popupMarker, data) {
        this.showCustomInfoWindow(data);
        myApp.urlManager.setUrlParam(this.urlParam, popupMarker.id);
    }


    showCustomInfoWindow(data) {
        const ownInfoWindow = document.querySelector('[data-own-infowindow]');
        if (!ownInfoWindow) {
            return;
        }

        const customModalManager = myApp.customModalManager
        const mapManager = myApp.mapManager
        const [userWebFavouriteGroupManager, loginManager] = ((userServices) => {
            if (!userServices) {
                return [null, null]
            }

            return [
                userServices.userWebFavouriteGroupManager,
                userServices.loginManager
            ]

        })(myApp.user)

        ownInfoWindow.innerHTML = data;
        const ownInfoWindowImage = ownInfoWindow.querySelector('[data-own-infowindow-image]');
        if (ownInfoWindowImage) {
            ownInfoWindowImage.addEventListener('load', () => {
                this.showInfoWindowWithAnimation($(ownInfoWindow));
            });
        }
        
        const loginUser = ownInfoWindow.querySelector('[data-open="login-user"]')
        if (loginUser && customModalManager) {
            loginUser.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                customModalManager.openModal('#userModal');
                loginManager.openLoginModal();
            });
        }

        myApp.collapseManager.initialize();
        if (userWebFavouriteGroupManager) {
            userWebFavouriteGroupManager.setAddFavouriteGroupClickListener(
                '.infowindow-container [data-action="add-favourite"]',
                $(myApp.mapManager.groupList),
                (groupId) => {
                    if (mapManager) {
                        mapManager.resetFavouriteOnSelectedMarker(groupId, true);
                    }
                }
            );
            userWebFavouriteGroupManager.setRemoveFavouriteGroupClickListener(
                '.infowindow-container [data-action="remove-favourite"]',
                $(myApp.mapManager.groupList),
                (groupId) => {
                    if (mapManager) {
                        mapManager.resetFavouriteOnSelectedMarker(groupId, false);
                    }
                } 
            );
        }
    };

    showInfoWindowWithAnimation(ownInfoWindow) {
        if (myApp.deviceDetector.isXsScreen() || myApp.deviceDetector.isSmScreen()) {
            ownInfoWindow.slideDown();
        } else {
            ownInfoWindow.fadeIn();
        }
    }

    showSkeletonInfoWindow() {
        let ownInfoWindow = $('[data-own-infowindow]');
        ownInfoWindow.hide();
        let infowindowSkeleton = $('#infowindow-skeleton-template').find('[data-target="skeleton-container"]').clone();
        ownInfoWindow.empty();
        ownInfoWindow.append(infowindowSkeleton);
        this.showInfoWindowWithAnimation(ownInfoWindow)
    };
}
